export const pagesPublicIdsEn = {
  add: {
    intro: {
      body: {
        itemCard: {
          nationalId: 'My Number',
          nationalIdType: 'National ID Type',
          personId: 'Person ID',
          purposeOfRegistration: 'Purpose of Registration',
          requiredDetails: 'Required details:'
        },
        nationalId: {
          title: 'National ID'
        },
        selectPublicIdType: 'Select the Type of Public ID'
      },
      header: {
        headerTitle: 'Add Public ID to your Registry'
      },
      options: {
        bulkCsvUpload: {
          button: 'Add',
          description: 'You can add data for multiple Public IDs, up to 500 records at a time. A CSV file following the DRESS CODE format is required.',
          selectedPublicIdType: 'Public ID type',
          title: 'Bulk add by uploading CSV file'
        },
        syncIT: 'Sync with external Public ID services'
      }
    }
  },
  addPublicId: 'Add Public ID',
  detail: {
    confirmDelete: {
      description: 'Are you sure you want to delete the data? This action cannot be undone.'
    },
    deleteData: 'Delete Data',
    fields: {
      expiryDate: 'Expiry Date',
      idNumber: 'ID Number',
      issueDate: 'Issue Date',
      issuingAuthority: 'Issuing Authority',
      lastUpdateDate: 'Last Update Date',
      lastUpdater: 'Last Updater',
      lastVerificationDate: 'Last Verification Date',
      legalBasis: 'Legal Basis',
      myNumber: 'My Number',
      nationalIdType: 'National ID Type',
      person: 'Person',
      proofOfPublicId: 'Proof of Public ID',
      purposeOfRegistration: 'Purpose of Registration',
      retentionPeriod: 'Retention Period',
      status: 'Status',
      viewProof: 'View Proof',
      worker: 'Worker'
    },
    files: {
      actions: 'Actions',
      count: '{{count}} items',
      deleteFileConfirmTitle: 'Delete file?',
      download: 'Download',
      empty: 'No uploaded files',
      error: 'Failed to load files',
      fileName: 'File Name',
      fileSize: 'Size:',
      fileType: 'Type:',
      loading: 'Loading...',
      open: 'Open',
      preview: 'Preview',
      title: 'File List',
      uploadDate: 'Uploaded:'
    },
    navigation: {
      compliance: 'Compliance',
      myNumber: 'My Number',
      publicIdCommon: 'Public ID Common'
    },
    navigationTitle: 'Sections',
    pageTitle: 'Public ID Details',
    sections: {
      myNumber: 'My Number',
      nationalRegistrationIdentityCard: 'National Registration Identity Card',
      publicIdCommon: 'Public ID Common',
      registration: 'Registration Detail'
    },
    tabs: {
      detail: 'Details',
      files: 'Files'
    }
  },
  importCsv: {
    checkValidColumn: {
      errors: 'errors',
      warnings: 'warnings'
    },
    completeDialog: {
      button: 'Done'
    },
    publicIdType: {
      exportFilename: {
        nationalId: 'NationalID'
      },
      prepareCsvFile: {
        templateTitle: {
          nationalId: 'New National ID'
        },
        updateExisting: {
          nationalId: 'Update existing National ID'
        }
      },
      title: {
        nationalId: 'National ID Bulk Import'
      },
      unit: {
        nationalId: 'National ID'
      }
    }
  },
  pageTitle: 'Public ID Management',
  registry: {
    categories: {
      all: {
        title: 'All'
      },
      nationalId: {
        title: 'National ID'
      }
    },
    filterPlaceholder: 'Search by name...',
    pageTitle: 'Public IDs',
    tabs: {
      all: 'All',
      nationalId: 'National ID',
      travelDocument: 'Travel Document'
    }
  },
  title: 'Public IDs'
};